export default __webpack_public_path__ + "static/media/rectangleimage.7e8a596f.png";